export default "__VITE_ASSET__DCoLdGpL__"